import { render, staticRenderFns } from "./TCLogo.vue?vue&type=template&id=1666194e&scoped=true&"
import script from "./TCLogo.vue?vue&type=script&lang=js&"
export * from "./TCLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666194e",
  null
  
)

export default component.exports